import {useEffect, useState} from 'react';
import './style.css';

const CONSENT_STORAGE_KEY = 'oogst_cookie_consent';

const trackingScripts = [
    {src: 'https://www.googletagmanager.com/gtm.js?id=GTM-KTFKMX4L'},
    {src: 'https://www.googletagmanager.com/gtag/js?id=G-7HP57BSVPS'},
    {src: 'https://www.clarity.ms/tag/omh0bk2mx0'},
    {src: 'https://connect.facebook.net/en_US/fbevents.js'},
];

function loadTrackingScripts() {
    if (document.querySelector('[data-consent-script]')) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
    window.gtag = window.gtag || function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', 'G-7HP57BSVPS');

    window.clarity = window.clarity || function clarity() {
        (window.clarity.q = window.clarity.q || []).push(arguments);
    };

    if (!window.fbq) {
        const fbq = function fbq() {
            if (fbq.callMethod) {
                fbq.callMethod.apply(fbq, arguments);
            } else {
                fbq.queue.push(arguments);
            }
        };
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        window.fbq = fbq;
        window._fbq = fbq;
    }
    window.fbq('init', '1663222994552389');
    window.fbq('track', 'PageView');

    trackingScripts.forEach(({src}) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = src;
        script.dataset.consentScript = 'true';
        document.head.appendChild(script);
    });
}

const getStoredConsent = () => {
    try {
        const value = window.localStorage.getItem(CONSENT_STORAGE_KEY);
        return value === 'granted' || value === 'denied' ? value : null;
    } catch {
        return null;
    }
};

export default function CookieConsent() {
    const [consent, setConsent] = useState(getStoredConsent);

    useEffect(() => {
        if (consent === 'granted') {
            loadTrackingScripts();
        }
    }, [consent]);

    const choose = (value) => {
        try {
            window.localStorage.setItem(CONSENT_STORAGE_KEY, value);
        } catch {
            // The in-memory choice still controls tracking for this page load.
        }
        setConsent(value);
    };

    if (consent) {
        return null;
    }

    return (
        <div className="cookie-consent-backdrop">
            <section
                aria-describedby="cookie-consent-description"
                aria-labelledby="cookie-consent-title"
                aria-modal="true"
                className="cookie-consent-modal"
                role="dialog"
            >
                <h2 id="cookie-consent-title">Cookievoorkeuren</h2>
                <p id="cookie-consent-description">
                    We gebruiken noodzakelijke cookies om Oogst.app goed te laten werken. Met jouw toestemming
                    gebruiken we ook cookies voor statistieken en marketing om de website te verbeteren.
                </p>
                <div className="cookie-consent-actions">
                    <button className="cookie-consent-secondary" onClick={() => choose('denied')} type="button">
                        Alleen noodzakelijk
                    </button>
                    <button className="cookie-consent-primary" onClick={() => choose('granted')} type="button">
                        Alles accepteren
                    </button>
                </div>
                <a href="/privacy-policy">Lees ons privacybeleid</a>
            </section>
        </div>
    );
}

export {CONSENT_STORAGE_KEY};
